export const COLUMN_WIDTHS = {
  productInfo: '350px',
  qty: '200px',
  unitPrice: '200px',
  gp: '320px',
  totalPrice: '120px',
  action: '48px'
} as const;

// Floors the columns shrink to when the table is too narrow to fit the ideal
// widths above. Sized to each column's actual content (steppers / price inputs /
// the dual GP inputs) so controls never clip. Above the combined floor the
// columns sit at COLUMN_WIDTHS and nothing changes on wide screens.
export const COLUMN_MIN_WIDTHS = {
  productInfo: '220px',
  qty: '160px',
  unitPrice: '120px',
  gp: '280px',
  totalPrice: '90px'
} as const;
